import { getFormValues } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import { IChangeChildrenCount } from '../../../actions/bookingCalendar/reservationModal/changeChildrenCount'
import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

function* changeChildren(action: IChangeChildrenCount) {
  const getForm = getFormValues(action.formName)
  const values: ICreateReservationFormValues = yield Effects.select(getForm)

  const { children } = values

  if (children.length > action.count) {
    for (let i = children.length; i > action.count; i--) {
      children.pop()
    }
  } else if (children.length < action.count) {
    for (let i = children.length; i < action.count; i++) {
      children.push({ age: '0' })
    }
  }
}

export default function* () {
  yield Effects.takeLatest(
    ReservationModalActions.ChangeChildren,
    changeChildren,
  )
}
